// DashboardLayout.tsx
import { Sidebar } from "@/components/Sidebar";
import { Outlet } from "react-router-dom";

export function DashboardLayout() {
  return (
    <div className="grid h-screen w-full grid-cols-[224px_1fr]">
      <Sidebar />
      <div>
        {/* Outlet is where your routed components will be rendered */}
        <Outlet />
      </div>
    </div>
  );
}
